export default __webpack_public_path__ + "static/media/tick.446b3133.svg";